import {
    REGISTRATION_SET_TOKEN,
    REGISTRATION_SET_DATA,
    REGISTRATION_SET_LOADING,
    REGISTRATION_SET_USER_ATTRIBUTES,
    REGISTRATION_SET_ERROR_MESSAGE,
    REGISTRATION_SHOW_CONFIRMATION_FORM,
    AUTH_SHOW_RESET_PASSWORD,
    LOGIN_SHOW_NEW_PASSWORD,
    AUTH_SHOW_LOGIN,
    AUTH_SET_PASSWORD_RESET_TOKEN,
    AUTH_SET_USER,
    REGISTRATION_SET_SHOW_POP_UP,
    REGISTRATION_SET_SHOW_HELP,
    REGISTRATION_SET_CREATE_OCCUPANCY,
    REGISTRATION_SET_SHOW_NOTIFICATION,
    SET_TERMS_ACCEPTED,
    SHOW_TERMS_OF_USE
} from '../actionTypes'

const defaultState = {
    token: null,
    data: null,
    loading: false,
    userAttributes: null,
    errorMessage: '',
    showConfirmationForm: false,
    showResetPassword: false,
    showNewPassword: false,
    showLogin: false,
    passwordResetToken: null,
    user: null,
    showPopUp: false,
    showHelp: false,
    showNotifications: false,
    createNewOccupancy: false,
    termsAccepted: false,
    showTermsOfUse: false,
    confirmationUsername: null,
    confirmationCode: null,
    resendConfirmation: false
}

const authReducer = (state = defaultState, action) => {
    switch (action.type) {
        case REGISTRATION_SET_TOKEN:
            return {
                ...state,
                token: action.value
            }

        case REGISTRATION_SET_DATA:
            return {
                ...state,
                data: action.data
            }

        case REGISTRATION_SET_LOADING:
            return {
                ...state,
                loading: action.loading
            }

        case REGISTRATION_SET_USER_ATTRIBUTES:
            return {
                ...state,
                userAttributes: action.attributes
            }

        case REGISTRATION_SET_ERROR_MESSAGE:
            return {
                ...state,
                errorMessage: action.message
            }

        case REGISTRATION_SHOW_CONFIRMATION_FORM:
            return {
                ...state,
                showConfirmationForm: true,
                confirmationUsername: action.username,
                confirmationCode: action.code,
                resendConfirmation: action.resend
            }

        case AUTH_SHOW_RESET_PASSWORD:
            return {
                ...state,
                showResetPassword: action.show,
                showLogin: !action.show,
                showNewPassword: false
            }

        case LOGIN_SHOW_NEW_PASSWORD:
            return {
                ...state,
                showNewPassword: action.show,
                showLogin: !action.show,
                showResetPassword: false
            }

        case AUTH_SHOW_LOGIN:
            return {
                ...state,
                showLogin: action.show,
                showNewPassword: false,
                showResetPassword: false
            }

        case AUTH_SET_PASSWORD_RESET_TOKEN:
            return {
                ...state,
                passwordResetToken: action.token
            }

        case AUTH_SET_USER:
            return {
                ...state,
                user: action.user
            }

        case REGISTRATION_SET_SHOW_POP_UP:
            return {
                ...state,
                showPopUp: action.showPopUp
            }

        case REGISTRATION_SET_SHOW_HELP:
            return {
                ...state,
                showHelp: action.show
            }

        case REGISTRATION_SET_SHOW_NOTIFICATION:
            return {
                ...state,
                showNotifications: action.show
            }

        case REGISTRATION_SET_CREATE_OCCUPANCY:
            return {
                ...state,
                createNewOccupancy: action.value
            }

        case SET_TERMS_ACCEPTED:
            return {
                ...state,
                termsAccepted: action.payload
            }

        case SHOW_TERMS_OF_USE:
            return {
                ...state,
                showTermsOfUse: action.payload
            }

        default:
            return state
    }
}

export default authReducer
